export const formatCurrency = (amount, currency) => {
  const value = Number(amount || 0) / 100;
  const currencyCode = (currency || "USD").toUpperCase();

  const formattedValue = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  if (currencyCode === "USD") {
    return `US$ ${formattedValue}`;
  }

  return `${currencyCode} ${formattedValue}`;
};
